import { colors as themeColors } from '../../../utils/theme';
import { useState, useEffect, useRef } from 'react';
import { Box, Paper, Grid, TextField, Autocomplete, Typography, Button, Dialog, DialogContent, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableFooter, useTheme, Snackbar, Alert } from '@mui/material';
import axios from 'axios';
import ClientMaster from '../../ClientMaster';
import { useAuth } from '../../../context/AuthContext';
import { useConfigure } from '../../../context/ConfigureContext';
import LeadSourceMaster from './LeadSourceMaster';
import ActivityMaster from './ActivityMaster';
import CurrencyMaster from '../../CurrencyMaster';
import LeadStatusMaster from './LeadStatusMaster';
import UserMaster from '../../UserMaster';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { useMediaQuery } from '@mui/system';
import { toProperCase } from '../../../utils/formatRows';

const transform = (data, idKey, valKey) => data.map(item => ({ id: item[idKey], label: item[valKey] }));

const parseDateFlexible = (dateStr) => {
    if (!dateStr || typeof dateStr !== 'string') return null;
    // Handle YYYY-MM-DD
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
        return dayjs(dateStr, 'YYYY-MM-DD');
    }
    // Handle DD/MM/YYYY
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateStr)) {
        return dayjs(dateStr, 'DD/MM/YYYY');
    }
    return null;
};


export default function ClientDetails({ initialData = {}, onNext, mode, connectionString, disablePartyName = false, isOrderLocked = false }) {
    const { user, selectedCompany, loading } = useAuth();
    const { isFeatureEnabled } = useConfigure();
    const showCurrency = isFeatureEnabled('Show Currency?');
    const companyId = selectedCompany?.CompId || null;
    const clientInit = initialData.client ?? initialData;
    console.log('Company search results:', clientInit);
    const API = connectionString;
    const partyDropdownRef = useRef(null);
    console.log("hii")
    // ─── client search state ─────────────────────────────────────────────
    const [companyName, setCompanyName] = useState(initialData.companyName || initialData.FirmName || '');
    const [selectedClientId, setSelectedClientId] = useState(initialData.clientId || null);
    const [searchResults, setSearchResults] = useState([]);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [clientError, setClientError] = useState(false);
    const [highlightedIndex, setHighlightedIndex] = useState(0);

    // ─── other form state ────────────────────────────────────────────────
    const [details, setDetails] = useState(initialData.details || []);
    const [error, setError] = useState('');
    const [quotationNumber, setquotationNumber] = useState(initialData.qoutationNumber || '');
    const [qoutationDate, setqoutationDate] = useState(mode === 'add' || mode === 'order' ? dayjs() : initialData.qoutationDate && dayjs(initialData.qoutationDate, 'DD/MM/YYYY').isValid() ? dayjs(initialData.qoutationDate, 'DD/MM/YYYY') : dayjs());
    const [referenceNumber, setReferenceNumber] = useState(initialData.referenceNumber || '');
    const [referenceDate, setReferenceDate] = useState(mode === 'add' ? null : initialData.referenceDate && parseDateFlexible(initialData.referenceDate) ? parseDateFlexible(initialData.referenceDate) : null);
    const [exchangeRate, setExchangeRate] = useState(initialData.exchangeRate || '');
    const [qnextFollowUpDate, setqnextFollowUpDate] = useState(mode === 'add' || mode === 'order' ? dayjs().add(7, 'day') : initialData.qnextFollowUpDate && dayjs(initialData.qnextFollowUpDate, 'DD/MM/YYYY').isValid() ? dayjs(initialData.qnextFollowUpDate, 'DD/MM/YYYY') : dayjs().add(7, 'day'));
    const [kindAttend, setKindAttend] = useState(initialData.kindAttend || '');
    const [project, setProject] = useState(initialData.project || '');
    const [agentName, setAgentName] = useState(initialData.agentName || '');
    const [agentCommission, setAgentCommission] = useState(initialData.agentCommission || '');
    const [remark, setRemark] = useState(initialData.remark || initialData.remarks || '');

    // ─── masters & popups ────────────────────────────────────────────────
    const [currencyOptions, setCurrencyOptions] = useState([]);
    const [selectedCurrency, setSelectedCurrency] = useState(null);
    const [leadSourceOptions, setLeadSourceOptions] = useState([]);
    const [selectedLeadSource, setSelectedLeadSource] = useState(null);
    const [employeeOptions, setEmployeeOptions] = useState([]);
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const [activityOptions, setActivityOptions] = useState([]);
    const [selectedActivity, setSelectedActivity] = useState(null);
    const [statusOptions, setStatusOptions] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState(null);

    const [openClientPopup, setOpenClientPopup] = useState(false);
    const [openCurrencyPopup, setOpenCurrencyPopup] = useState(false);
    const [openLeadSourcePopup, setOpenLeadSourcePopup] = useState(false);
    const [openEmployeePopup, setOpenEmployeePopup] = useState(false);
    const [openActivityPopup, setOpenActivityPopup] = useState(false);
    const [openStatusPopup, setOpenStatusPopup] = useState(false);

    const [termsOptions, setTermsOptions] = useState([]);
    const [selectedTerms, setSelectedTerms] = useState(initialData.selectedTerms || null);
    const [termsInputValue, setTermsInputValue] = useState('');



    const fetchLastTerms = async () => {
        try {
            const res = await axios.get(`${API}/api/last-terms-type`, {
                params: {
                    mode: 'SaleOrder',
                    companyId
                }
            });

            const termsValue = res?.data?.TermsType;
            
            console.log("modeee", mode)

            // Only for add/ref mode
            if (
                termsValue &&
                (mode === 'add' || mode === 'order' || mode === 'ref')
            ) {
                setSelectedTerms({
                    label: String(termsValue)
                });
            }

        } catch (err) {
            console.error("Error fetching last terms", err);
        }
    };

    useEffect(() => {
        const fetchTerms = async () => {
            try {
                const { data: response } = await axios.get(`${API}/api/termscondition/search`, {
                    params: { companyId, mode: 'search' },
                    validateStatus: (status) => status >= 200 && status < 400,
                });
                const data = Array.isArray(response?.data) ? response.data : Array.isArray(response) ? response : [];
                console.log(data)
                const options = data.map(item => ({
                    label: item.TermsType || item.TermsName || ''
                }));
                setTermsOptions(options);
            } catch (err) {
                console.error('Error fetching terms:', err);
                setTermsOptions([]);
            }
        };

        if (companyId) {
            fetchTerms();
            fetchLastTerms();
        }


    }, [companyId]);



    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const isEditLocked = mode === 'edit' && isOrderLocked;

    const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

    const requiredAsteriskStyle = { '& .MuiFormLabel-asterisk': { color: 'red', }, };

    const handlePopupClose = (data) => {
        if (data?.success) {
            setSnackbar({ open: true, message: data.message, severity: "success" });
        }
    };

    // ─── Sync referenceDate with qoutationDate only in add mode ───────────
    useEffect(() => {
        if (mode === 'add') {
            setReferenceDate(qoutationDate);
        }
    }, [qoutationDate, mode]);

    // ─── When currencyOptions load or initialData.currencyId changes ──────
    useEffect(() => {
        if (!currencyOptions || currencyOptions.length === 0) return;
        const cid = initialData?.currencyId ?? null;
        if (cid == null) return;
        const found = currencyOptions.find(opt => String(opt.id) === String(cid));
        if (found) {
            setSelectedCurrency(found);
        } else {
            setSelectedCurrency({ id: null, label: '-' });
        }
    }, [currencyOptions, initialData?.currencyId]);

    // ─── Load auto-generated order number with StartFromNumber logic ─────
    useEffect(() => {
        if (mode !== 'edit' && companyId) {
            fetchReceiptNo();
        }
    }, [mode, companyId]);

    async function fetchReceiptNo() {
        try {
            const { data } = await axios.get(`${API}/api/get-saleOrder-Number`, { headers: { 'Cache-Control': 'no-cache' }, params: { companyId } });
            console.log('[STEP4] Fetched sale order number:', data);
            setquotationNumber(data.saleOrderNumber || '');
        } catch (err) {
            console.error('Error fetching sale order number:', err);
            setquotationNumber('');
        }
    }

    // ─── Load all master lists ────────────────────────────────────────────
    useEffect(() => {
        const fetchMasters = async () => {
            try {
                const [cur] = await Promise.all([axios.get(`${API}/currencymaster/search?mode=search&companyId=${companyId}`)]);
                const currencyData = transform(cur.data || [], 'CurrencyId', 'CurrencySymbol');
                console.log(cur.data);
                setCurrencyOptions(currencyData);
                if (initialData.currencyId) {
                    const found = currencyData.find(opt => String(opt.id) === String(initialData.currencyId));
                    setSelectedCurrency(found || { id: null, label: '-' });
                } else {
                    setSelectedCurrency({ id: null, label: '-' });
                }
            } catch (err) {
                console.error('Error fetching masters:', err);
                setCurrencyOptions([]);
                setLeadSourceOptions([]);
                setEmployeeOptions([]);
                setActivityOptions([]);
                setStatusOptions([]);
                setSelectedCurrency({ id: null, label: '-' });
                setSelectedLeadSource({ id: null, label: '-' });
                setSelectedEmployee({ id: null, label: '-' });
                setSelectedActivity({ id: null, label: '-' });
                setSelectedStatus({ id: null, label: '-' });
            }
        };
        fetchMasters();
    }, []);

    // ─── Initialize from initialData ─────────────────────────────────────
    useEffect(() => {
        if (!initialData || Object.keys(initialData).length === 0) return;

        setCompanyName(initialData.companyName || initialData.FirmName || '');
        setSelectedClientId(initialData.clientId ?? null);

        if (mode === 'edit') {
            setSelectedTerms(
                initialData.TermsType
                    ? {
                        id: initialData.TermsType,
                        label: String(initialData.TermsType)
                    }
                    : null
            );
        }

        if (initialData.details) {
            if (Array.isArray(initialData.details)) {
                setDetails(initialData.details);
            } else if (typeof initialData.details === 'object') {
                const arr = Object.entries(initialData.details).map(([label, value]) => ({ label, value }));
                setDetails(arr);
            }
        } else {
            const c = { city: initialData.city || '', state: initialData.state || '', mobileNo: initialData.mobileNo || '', emailId: initialData.emailId || '', contactPerson: initialData.contactPerson || '', gstNumber: initialData.gstNumber || '' };
            setDetails([
                { label: 'City', value: c.city },
                { label: 'State', value: c.state },
                { label: 'mobileNo', value: c.mobileNo },
                { label: 'Email', value: c.emailId },
                { label: 'ContactPerson', value: c.contactPerson },
                { label: 'GST No.', value: c.gstNumber }
            ]);
        }

        if (mode === 'edit') {
            setqoutationDate(initialData.inquiryDate ? parseDateFlexible(initialData.inquiryDate) || dayjs() : dayjs());
            setReferenceDate(initialData.referenceDate ? parseDateFlexible(initialData.referenceDate) || null : null);
            setqnextFollowUpDate(initialData.nextFollowUpDate ? parseDateFlexible(initialData.nextFollowUpDate) || dayjs().add(7, 'day') : dayjs().add(7, 'day'));
            setReferenceNumber(initialData.referenceNumber || '');
            setquotationNumber(initialData.quotationNumber || '');
        } else if (mode === 'order') {
            setqoutationDate(dayjs());
            setReferenceDate(initialData.inquiryDate ? parseDateFlexible(initialData.inquiryDate) || null : null);
            setqnextFollowUpDate(initialData.nextFollowUpDate ? parseDateFlexible(initialData.nextFollowUpDate) || dayjs().add(7, 'day') : dayjs().add(7, 'day'));
            setReferenceNumber(initialData.qoutationNumber || '');
        } else if (mode === 'add') {
            setqoutationDate(dayjs());
            setReferenceDate(null);
            setqnextFollowUpDate(dayjs().add(7, 'day'));
            setReferenceNumber(initialData.referenceNumber || '');
        }

        setExchangeRate(initialData.exchangeRate || '');
        setKindAttend(initialData.kindAttend || '');
        setProject(initialData.project || '');
        setAgentName(initialData.agentName || '');
        setAgentCommission(initialData.agentCommission || '');
        setRemark(initialData.remark || initialData.remarks || '');
    }, [initialData, mode]);

    // ─── Fetch search results ─────────────────────────────────────────────
    // Debounced 350ms so a fast typist doesn't fire one API call per keystroke —
    // the search still starts automatically as the user types, just waits for a
    // brief pause before actually calling the API.
    useEffect(() => {
        if (!companyName || !dropdownOpen) {
            setSearchResults([]);
            return;
        }

        const timeoutId = setTimeout(() => {
            const fetch = async () => {
                try {
                    const res = await axios.get(`${API}/api/company-search`, { params: { field: 'FirmName', search: companyName, companyId } });
                    const data = Array.isArray(res.data.data) ? res.data.data : [];
                    console.log('Company search results:', data);
                    setSearchResults(data);
                    setHighlightedIndex(0); // reset so the first result is highlighted for Enter-to-select
                } catch (err) {
                    console.error('Error fetching company search results:', err);
                    setSearchResults([]);
                }
            };
            fetch();
        }, 350);

        return () => clearTimeout(timeoutId);
    }, [companyName, dropdownOpen]);

    // ─── Handle row selection in table ────────────────────────────────────
    const onSelectResult = r => {
        setSelectedClientId(r.id);
        setCompanyName(r.FirmName || r.companyName || '');
        setAgentName(r.AgentName || '');
        setAgentCommission(r.AgentComm || '');

        const c = { City: r.City || '', state: r.state || '', MobileNo: r.MobileNo || '', EmailId: r.EmailId || '', ContactPerson: r.ContactPerson || '', GSTNo: r.GSTNo || '' };
        setDetails([
            { label: 'City', value: c.City },
            { label: 'State', value: c.state },
            { label: 'mobileNo', value: c.MobileNo },
            { label: 'Email', value: c.EmailId },
            { label: 'ContactPerson', value: c.ContactPerson },
            { label: 'GST No.', value: c.GSTNo }
        ]);
        setDropdownOpen(false);
        setClientError(false);
    };

    // ─── Dropdown field for Autocomplete ──────────────────────────────────
    const dropdownField = (label, options, value, setValue) => (
        <Grid item xs={12} sm={8} md={12}>
            <Autocomplete fullWidth options={options} getOptionLabel={opt => opt?.label || ''} value={value} onChange={(_, v) => setValue(v)} isOptionEqualToValue={(opt, val) => String(opt?.id) === String(val?.id)} disabled={!isEditable}
                renderInput={params => (
                    <TextField {...params} label={label} size="small" InputLabelProps={{ shrink: Boolean(value) }} sx={{ '& .MuiOutlinedInput-root': { height: 40, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }} />
                )}
            />
        </Grid>
    );

    // ─── Next button ─────────────────────────────────────────────────────
    const handleNext = () => {
        if (!companyName && !quotationNumber) {
            setError('Party & Order No. are required.');
            return;
        }
        if (!selectedClientId) {
            setClientError(true);
            return;
        }
        setError('');
        console.log('Selected currency (state):', selectedCurrency);
        console.log('Exchange rate (state):', exchangeRate);
        console.log('kindAttend, project, remark:', kindAttend, project, remark);

        const payload = {
            clientId: selectedClientId, inquiryNumber: quotationNumber, companyName, inquiryDate: qoutationDate && qoutationDate.isValid() ? qoutationDate.format('YYYY-MM-DD') : '', referenceNumber, referenceDate: referenceDate && referenceDate.isValid() ? referenceDate.format('YYYY-MM-DD') : '', editreferenceNumber: initialData?.editreferenceNumber || '', currencyId: selectedCurrency?.id ?? null, exchangeRate: exchangeRate === '' ? '' : Number(exchangeRate), nextFollowUpDate: qnextFollowUpDate && qnextFollowUpDate.isValid() ? qnextFollowUpDate.format('YYYY-MM-DD') : '', kindAttend, remarks: remark, project, selectedEmployee: selectedEmployee?.id ?? null, selectedLeadSource: selectedLeadSource?.id ?? null, selectedActivity: selectedActivity?.id ?? null, selectedStatus: selectedStatus?.id ?? null, agentName, agentCommission,
            TermsType: selectedTerms?.label || null,
            details: details.reduce((acc, curr) => {
                acc[curr.label] = curr.value;
                return acc;
            }, {}),
        };

        console.log('ClientDetails onNext payload:', payload);
        onNext(payload);
    };

    // ─── Allow editing only in 'add' or 'edit' modes ─────────────────────
    const isEditable = mode === 'add' || mode === 'edit' || mode === 'order';

    return (
        <Paper elevation={2} sx={{ p: 1, overflowX: 'hidden' }}>
            <Box display="flex" justifyContent="space-between" flexWrap="wrap" pt={1}>
                <Box sx={{ width: { xs: "100%", md: "calc(50% - 16px)" }, pr: { md: 3 } }}>
                    {/* Party dropdown */}
                    <Box ref={partyDropdownRef} tabIndex={-1} sx={{ position: 'relative', flex: '1 1 40%' }}
                        onBlur={e => {
                            if (!partyDropdownRef.current.contains(e.relatedTarget)) {
                                setDropdownOpen(false);
                            }
                        }}
                    >
                        <TextField autoFocus={mode === 'add'} disabled={!isEditable || disablePartyName || isEditLocked} fullWidth size="small" label="Party Name" variant="outlined" value={toProperCase(companyName)} required InputLabelProps={{ shrink: Boolean(companyName), sx: requiredAsteriskStyle }} sx={{ '& .MuiOutlinedInput-root': { height: '38px', display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { padding: '0 12px' } }} helperText={clientError ? "Client does not exist. Please add new client or select from the List" : ""} error={clientError}
                            onChange={e => {
                                setCompanyName(toProperCase(e.target.value));
                                setDropdownOpen(true);
                                setSelectedClientId(null);   //  invalidate
                                setClientError(false);
                            }}
                            onBlur={() => {
                                if (companyName && !selectedClientId) {
                                    setClientError(true);
                                }
                            }}
                            onKeyDown={(e) => {
                                if (!dropdownOpen || searchResults.length === 0) return;
                                if (e.key === 'ArrowDown') {
                                    e.preventDefault();
                                    setHighlightedIndex((prev) => Math.min(prev + 1, searchResults.length - 1));
                                } else if (e.key === 'ArrowUp') {
                                    e.preventDefault();
                                    setHighlightedIndex((prev) => Math.max(prev - 1, 0));
                                } else if (e.key === 'Enter') {
                                    e.preventDefault();
                                    const selected = searchResults[highlightedIndex];
                                    if (selected) {
                                        onSelectResult(selected);
                                        setCompanyName(toProperCase(selected.FirmName));
                                        setClientError(false);
                                        setDropdownOpen(false);
                                    }
                                } else if (e.key === 'Escape') {
                                    setDropdownOpen(false);
                                }
                            }}
                        />

                        {dropdownOpen && companyName && (
                            <Paper elevation={0} sx={{ mt: 1, position: 'absolute', width: { xs: '100%', lg: '800px' }, zIndex: 10, border: '1px solid rgba(0,0,0,0.2)', borderRadius: 1, maxHeight: 240, overflowY: 'auto' }} >
                                {isSmallScreen ? (
                                    /* ===================== CARD VIEW (SM / XS) ===================== */
                                    <>
                                        {searchResults.length > 0 ? (
                                            searchResults.map((r, i) => (
                                                <Box key={i} sx={{ p: 1.2, borderBottom: `1px solid ${themeColors.neutral.border}`, cursor: 'pointer', backgroundColor: i === highlightedIndex ? 'action.selected' : 'transparent' }}
                                                    onMouseEnter={() => setHighlightedIndex(i)}
                                                    onMouseDown={() => {
                                                        onSelectResult(r);
                                                        // setSelectedClientId(r.ClientId);
                                                        setCompanyName(toProperCase(r.FirmName));
                                                        setClientError(false);
                                                        setDropdownOpen(false);
                                                    }}
                                                >
                                                    <Box sx={{ fontWeight: 600, fontSize: '0.85rem' }}> {toProperCase(r.FirmName)} </Box>
                                                    <Box sx={{ fontSize: '0.75rem', color: 'text.secondary' }}> GST: {r.GSTNo || '-'} </Box>
                                                    <Box sx={{ fontSize: '0.75rem' }}> {toProperCase(r.ContactPerson) || '-'} • {r.MobileNo || '-'} </Box>
                                                    <Box sx={{ fontSize: '0.75rem', color: 'text.secondary' }}> {toProperCase(r.City) || '-'} </Box>
                                                </Box>
                                            ))
                                        ) : (<Box sx={{ p: 2, textAlign: 'center', color: 'error.main' }}> Client not found </Box>)}

                                        {/* Sticky Add New Client */}
                                        <Box onMouseDown={() => setOpenClientPopup(true)} sx={{ position: 'sticky', bottom: 0, backgroundColor: themeColors.neutral.surface, textAlign: 'center', p: 1, fontWeight: 600, color: 'primary.main', cursor: 'pointer', boxShadow: '0 -2px 6px rgba(0,0,0,0.08)' }} >
                                            ➕ Add New Client
                                        </Box>
                                    </>
                                ) : (
                                    /* ===================== TABLE VIEW (MD / LG) ===================== */
                                    <Table size="small" stickyHeader>
                                        <TableHead>
                                            <TableRow>
                                                {['Company', 'GST No', 'Contact', 'Mobile', 'City'].map(h => (
                                                    <TableCell key={h} sx={{ backgroundColor: themeColors.neutral.line, fontWeight: 600, fontSize: '0.75rem', position: 'sticky', top: 0, zIndex: 1 }} >
                                                        {h}
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {searchResults.length > 0 ? (
                                                searchResults.map((r, i) => (
                                                    <TableRow key={i} hover selected={i === highlightedIndex} sx={{ cursor: 'pointer' }}
                                                        onMouseEnter={() => setHighlightedIndex(i)}
                                                        onMouseDown={() => {
                                                            onSelectResult(r);
                                                            setCompanyName(toProperCase(r.FirmName));
                                                            setClientError(false);
                                                            setDropdownOpen(false);
                                                        }}
                                                    >
                                                        <TableCell>{toProperCase(r.FirmName)}</TableCell>
                                                        <TableCell>{r.GSTNo}</TableCell>
                                                        <TableCell>{toProperCase(r.ContactPerson)}</TableCell>
                                                        <TableCell>{r.MobileNo}</TableCell>
                                                        <TableCell>{toProperCase(r.City)}</TableCell>
                                                    </TableRow>
                                                ))
                                            ) : (
                                                <TableRow>
                                                    <TableCell colSpan={5} align="center" sx={{ color: 'error.main' }}> Client not found </TableCell>
                                                </TableRow>
                                            )}
                                        </TableBody>

                                        <TableFooter sx={{ position: 'sticky', bottom: 0, backgroundColor: themeColors.neutral.surface }} >
                                            <TableRow hover onMouseDown={() => setOpenClientPopup(true)}>
                                                <TableCell colSpan={5} align="center" sx={{ color: 'primary.main', fontWeight: 600 }}>  ➕ Add New Client </TableCell>
                                            </TableRow>
                                        </TableFooter>
                                    </Table>
                                )}
                            </Paper>
                        )}
                    </Box>

                    {/* Details display */}
                    <Grid item xs={12} md={4} pt={2}>
                        <TextField fullWidth size="small" label="Address" variant="outlined" disabled value={Array.isArray(details) ? toProperCase(details.map(d => `${d.label}: ${d.value}`).join(', ')) : ''} multiline rows={2.5} InputLabelProps={{ shrink: Array.isArray(details) && details.length > 0 }} sx={{ '& .MuiOutlinedInput-root': { height: "auto", display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }} />
                    </Grid>

                    <Box display="flex" gap={2} flex="1 1 40%" pt={2}>
                        <Box sx={{ flex: '0 0 48%' }}>
                            <TextField fullWidth size="small" label="Kind Attend" value={kindAttend} onChange={e => setKindAttend(e.target.value)} InputLabelProps={{ shrink: Boolean(kindAttend) }} disabled={!isEditable} sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' }, }} />
                        </Box>
                        <Box sx={{ flex: '0 0 48%' }}>
                            <TextField fullWidth size="small" label="Project" value={project} onChange={e => setProject(e.target.value)} InputLabelProps={{ shrink: Boolean(project) }} disabled={!isEditable} sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' }, }} />
                        </Box>
                    </Box>

                    <Box sx={{ mt: 2 }}>
                        <TextField fullWidth size="small" label="Remark" disabled={!isEditable} multiline minRows={1} maxRows={6} value={remark} InputLabelProps={{ shrink: Boolean(remark) }} inputProps={{ maxLength: 250 }} sx={{ '& .MuiOutlinedInput-root': { height: 'auto', alignItems: 'flex-start' } }}
                            onChange={(e) => {
                                const val = e.target.value;
                                if (val.length <= 250) setRemark(val);
                                else setRemark(val.slice(0, 250));
                            }}
                        />
                        <Typography variant="caption" sx={{ display: 'block', mt: 0.5, textAlign: 'right', color: 'text.secondary' }}>
                            {remark.length}/250
                        </Typography>
                    </Box>

                    <Box display="flex" justifyContent="flex-start">
                        <Box sx={{ width: '20%', mt: "-8px" }}>
                            <Autocomplete
                                fullWidth
                                size="small"
                                options={termsOptions}
                                getOptionLabel={(opt) => opt?.label || ''}
                                value={selectedTerms}
                                onChange={(_, v) => setSelectedTerms(v)}
                                noOptionsText="Not Found"
                                inputValue={termsInputValue}
                                onInputChange={(_, newInputValue) => setTermsInputValue(newInputValue)}
                                isOptionEqualToValue={(opt, val) => String(opt?.id) === String(val?.id)}
                                // disabled={!isEditable}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Terms"
                                        size="small"
                                        InputLabelProps={{ shrink: Boolean(selectedTerms || termsInputValue) }}
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                height: 38,
                                                display: 'flex',
                                                alignItems: 'center'
                                            },
                                            '& .MuiOutlinedInput-input': {
                                                fontSize: '0.875rem',
                                                padding: '0 12px'
                                            }
                                        }}
                                    />
                                )}
                            />
                        </Box>
                    </Box>
                </Box>

                <Box sx={{ width: { xs: "100%", md: "calc(50% - 46px)" }, pt: { xs: 2, md: 0 } }} alignSelf="right">
                    <Box display="flex" gap={2} flex="1 1 40%">
                        <Box sx={{ flex: '0 0 48%' }}>
                            <TextField fullWidth size="small" label="Order No." variant='outlined' value={quotationNumber} disabled InputLabelProps={{ shrink: true }} sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' }, }} />
                        </Box>

                        <Box sx={{ flex: '0 0 48%' }}>
                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
                                <DatePicker label="Order Date" value={qoutationDate} onChange={setqoutationDate}
                                    slots={{
                                        textField: (params) => (
                                            <TextField {...params} size="small" variant="outlined" value={qoutationDate ? dayjs(qoutationDate).format('DD/MM/YYYY') : ''} InputLabelProps={{ shrink: true }} disabled sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' }, }} />
                                        ),
                                    }}
                                />
                            </LocalizationProvider>
                        </Box>
                    </Box>

                    <Box display="flex" gap={2} flex="1 1 40%" pt={2}>
                        <Box sx={{ flex: '0 0 48%' }}>
                            <TextField fullWidth size="small" variant='outlined' label="Party PO No." value={referenceNumber} onChange={e => setReferenceNumber(e.target.value)} InputLabelProps={{ shrink: Boolean(referenceNumber) }} disabled={!isEditable || isEditLocked} sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' }, }} />
                        </Box>

                        <Box sx={{ flex: '0 0 48%' }}>
                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
                                <DatePicker label="Party PO Dt" value={referenceDate} onChange={(newValue) => setReferenceDate(newValue)} disabled={!isEditable || isEditLocked}
                                    slots={{
                                        textField: (params) => (
                                            <TextField {...params} fullWidth size="small" variant="outlined" value={referenceDate && referenceDate.isValid() ? referenceDate.format('DD/MM/YYYY') : ''} InputLabelProps={{ shrink: Boolean(referenceDate) || mode === 'add' }}
                                                sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' }, }}
                                            />
                                        )
                                    }}
                                />
                            </LocalizationProvider>
                        </Box>
                    </Box>

                    <Box display="flex" gap={2} flex="1 1 40%" pt={2}>
                        {showCurrency && (
                        <Box sx={{ flex: '0 0 48%', display: 'flex', gap: 1, alignItems: 'center' }}>
                            <Box sx={{ flex: '0 0 50%' }}> {dropdownField('Currency', currencyOptions, selectedCurrency, setSelectedCurrency)} </Box>
                            <Box sx={{ flex: '0 0 47%' }}>
                                <TextField fullWidth size="small" type="number" variant="outlined" label="Ex Rate" value={exchangeRate} InputLabelProps={{ shrink: Boolean(exchangeRate) }} disabled={!isEditable} sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' }, }}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        if (/^\d*\.?\d{0,2}$/.test(value)) {
                                            setExchangeRate(value);
                                        }
                                    }}
                                />
                            </Box>
                        </Box>
                        )}
                    </Box>

                    <Box display="flex" gap={2} flex="1 1 40%" pt={2}>
                        <Box sx={{ flex: '0 0 48%' }}> <TextField fullWidth label="Agent Name" value={toProperCase(agentName)} onChange={e => setAgentName(toProperCase(e.target.value))} InputLabelProps={{ shrink: Boolean(agentName) }} variant="outlined" size="small" disabled={!isEditable} sx={{ '& .MuiOutlinedInput-root': { backgroundColor: 'white', height: '40px' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 10px' } }} /> </Box>

                        <Box sx={{ flex: '0 0 48%' }}>
                            <TextField fullWidth label="Agent Commission (%)" value={agentCommission} InputLabelProps={{ shrink: Boolean(agentCommission) }} variant="outlined" size="small" type="number" disabled={!isEditable} sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' }, }}
                                onChange={e => {
                                    const v = e.target.value;
                                    if (v === '') {
                                        setAgentCommission('');
                                        return;
                                    }
                                    const re = /^(?:100(?:\.(?:0{0,2}))?|[0-9]{1,2}(?:\.\d{0,2})?)$/;
                                    if (re.test(v)) {
                                        setAgentCommission(v);
                                    }
                                }}
                            />
                        </Box>
                    </Box>
                </Box>
            </Box>

            {!!error && (<Typography color="error" mt={2}> {error} </Typography>)}

            <Box mt={4} display="flex" justifyContent="flex-end"> <Button variant="contained" onClick={handleNext} disabled={!selectedClientId}>Next</Button> </Box>

            {/* Popups */}
            <Dialog open={openClientPopup} fullWidth maxWidth="md" onClose={(event, reason) => {
                if (reason === 'backdropClick') return;
                setOpenClientPopup(false);
            }} PaperProps={{
                sx: {
                    width: { xs: "95%", },
                    m: { xs: 0 }
                }
            }}>
                <DialogContent sx={{ p: { xs: 0 } }}>
                    <ClientMaster mode="add" onPopupCancel={(data) => { handlePopupClose(data); setOpenClientPopup(false) }} connectionString={connectionString} />
                </DialogContent>
            </Dialog>
            <Dialog open={openCurrencyPopup} onClose={() => setOpenCurrencyPopup(false)}>
                <DialogContent>
                    <CurrencyMaster mode="add" onPopupCancel={() => setOpenCurrencyPopup(false)} connectionString={connectionString} />
                </DialogContent>
            </Dialog>
            <Dialog open={openLeadSourcePopup} onClose={() => setOpenLeadSourcePopup(false)}>
                <DialogContent>
                    <LeadSourceMaster mode="add" onPopupCancel={() => setOpenLeadSourcePopup(false)} connectionString={connectionString} />
                </DialogContent>
            </Dialog>
            <Dialog open={openEmployeePopup} onClose={() => setOpenEmployeePopup(false)}>
                <DialogContent>
                    <UserMaster mode="add" onPopupCancel={() => setOpenEmployeePopup(false)} connectionString={connectionString} />
                </DialogContent>
            </Dialog>
            <Dialog open={openActivityPopup} onClose={() => setOpenActivityPopup(false)}>
                <DialogContent>
                    <ActivityMaster mode="add" onPopupCancel={() => setOpenActivityPopup(false)} connectionString={connectionString} />
                </DialogContent>
            </Dialog>
            <Dialog open={openStatusPopup} onClose={() => setOpenStatusPopup(false)}>
                <DialogContent>
                    <LeadStatusMaster mode="add" onPopupCancel={() => setOpenStatusPopup(false)} connectionString={connectionString} />
                </DialogContent>
            </Dialog>

            <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={() => setSnackbar(s => ({ ...s, open: false }))} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} >
                <Alert onClose={() => setSnackbar(s => ({ ...s, open: false }))} severity={snackbar.severity} variant="filled" sx={{ width: '100%' }} >
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </Paper>
    );
}


// import { useState, useEffect, useRef } from 'react';
// import { Box, Paper, Grid, TextField, Autocomplete, Typography, Button, Dialog, DialogContent, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableFooter, useTheme, Snackbar, Alert } from '@mui/material';
// import axios from 'axios';
// import ClientMaster from '../../ClientMaster';
// import { useAuth } from '../../../context/AuthContext';
// import LeadSourceMaster from './LeadSourceMaster';
// import ActivityMaster from './ActivityMaster';
// import CurrencyMaster from '../../CurrencyMaster';
// import LeadStatusMaster from './LeadStatusMaster';
// import UserMaster from '../../UserMaster';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import dayjs from 'dayjs';
// import { useMediaQuery } from '@mui/system';
// import { toProperCase } from '../../../utils/formatRows';

// const transform = (data, idKey, valKey) => data.map(item => ({ id: item[idKey], label: item[valKey] }));

// const parseDateFlexible = (dateStr) => {
//     if (!dateStr || typeof dateStr !== 'string') return null;
//     // Handle YYYY-MM-DD
//     if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
//         return dayjs(dateStr, 'YYYY-MM-DD');
//     }
//     // Handle DD/MM/YYYY
//     if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateStr)) {
//         return dayjs(dateStr, 'DD/MM/YYYY');
//     }
//     return null;
// };


// export default function ClientDetails({ initialData = {}, onNext, mode, connectionString, disablePartyName = false, isOrderLocked = false }) {
//     const { user, selectedCompany, loading } = useAuth();
//     const companyId = selectedCompany?.CompId || null;
//     const clientInit = initialData.client ?? initialData;
//     console.log('Company search results:', clientInit);
//     const API = connectionString;
//     const partyDropdownRef = useRef(null);
//     console.log("hii")
//     // ─── client search state ─────────────────────────────────────────────
//     const [companyName, setCompanyName] = useState(initialData.companyName || initialData.FirmName || '');
//     const [selectedClientId, setSelectedClientId] = useState(initialData.clientId || null);
//     const [searchResults, setSearchResults] = useState([]);
//     const [dropdownOpen, setDropdownOpen] = useState(false);
//     const [clientError, setClientError] = useState(false);

//     // ─── other form state ────────────────────────────────────────────────
//     const [details, setDetails] = useState(initialData.details || []);
//     const [error, setError] = useState('');
//     const [quotationNumber, setquotationNumber] = useState(initialData.qoutationNumber || '');
//     const [qoutationDate, setqoutationDate] = useState(mode === 'add' || mode === 'order' ? dayjs() : initialData.qoutationDate && dayjs(initialData.qoutationDate, 'DD/MM/YYYY').isValid() ? dayjs(initialData.qoutationDate, 'DD/MM/YYYY') : dayjs());
//     const [referenceNumber, setReferenceNumber] = useState(initialData.referenceNumber || '');
//     const [referenceDate, setReferenceDate] = useState(mode === 'add' ? null : initialData.referenceDate && parseDateFlexible(initialData.referenceDate) ? parseDateFlexible(initialData.referenceDate) : null);
//     const [exchangeRate, setExchangeRate] = useState(initialData.exchangeRate || '');
//     const [qnextFollowUpDate, setqnextFollowUpDate] = useState(mode === 'add' || mode === 'order' ? dayjs().add(7, 'day') : initialData.qnextFollowUpDate && dayjs(initialData.qnextFollowUpDate, 'DD/MM/YYYY').isValid() ? dayjs(initialData.qnextFollowUpDate, 'DD/MM/YYYY') : dayjs().add(7, 'day'));
//     const [kindAttend, setKindAttend] = useState(initialData.kindAttend || '');
//     const [project, setProject] = useState(initialData.project || '');
//     const [agentName, setAgentName] = useState(initialData.agentName || '');
//     const [agentCommission, setAgentCommission] = useState(initialData.agentCommission || '');
//     const [remark, setRemark] = useState(initialData.remark || initialData.remarks || '');

//     // ─── masters & popups ────────────────────────────────────────────────
//     const [currencyOptions, setCurrencyOptions] = useState([]);
//     const [selectedCurrency, setSelectedCurrency] = useState(null);
//     const [leadSourceOptions, setLeadSourceOptions] = useState([]);
//     const [selectedLeadSource, setSelectedLeadSource] = useState(null);
//     const [employeeOptions, setEmployeeOptions] = useState([]);
//     const [selectedEmployee, setSelectedEmployee] = useState(null);
//     const [activityOptions, setActivityOptions] = useState([]);
//     const [selectedActivity, setSelectedActivity] = useState(null);
//     const [statusOptions, setStatusOptions] = useState([]);
//     const [selectedStatus, setSelectedStatus] = useState(null);

//     const [openClientPopup, setOpenClientPopup] = useState(false);
//     const [openCurrencyPopup, setOpenCurrencyPopup] = useState(false);
//     const [openLeadSourcePopup, setOpenLeadSourcePopup] = useState(false);
//     const [openEmployeePopup, setOpenEmployeePopup] = useState(false);
//     const [openActivityPopup, setOpenActivityPopup] = useState(false);
//     const [openStatusPopup, setOpenStatusPopup] = useState(false);

//     const [termsOptions, setTermsOptions] = useState([]);
//     const [selectedTerms, setSelectedTerms] = useState(initialData.selectedTerms || null);



//     const fetchLastTerms = async () => {
//         try {
//             const res = await axios.get(`${API}/api/last-terms-type`, {
//                 params: {
//                     mode: 'SaleOrder',
//                     companyId
//                 }
//             });

//             const termsValue = res?.data?.TermsType;
            
//             console.log("modeee", mode)

//             // Only for add/ref mode
//             if (
//                 termsValue &&
//                 (mode === 'add' || mode === 'order' || mode === 'ref')
//             ) {
//                 setSelectedTerms({
//                     label: String(termsValue)
//                 });
//             }

//         } catch (err) {
//             console.error("Error fetching last terms", err);
//         }
//     };

//     useEffect(() => {
//         const fetchTerms = async () => {
//             try {
//                 const { data: response } = await axios.get(`${API}/api/termscondition/search`, {
//                     params: { companyId, mode: 'search' },
//                     validateStatus: (status) => status >= 200 && status < 400,
//                 });
//                 const data = Array.isArray(response?.data) ? response.data : Array.isArray(response) ? response : [];
//                 console.log(data)
//                 const options = data.map(item => ({
//                     label: item.TermsType || item.TermsName || ''
//                 }));
//                 setTermsOptions(options);
//             } catch (err) {
//                 console.error('Error fetching terms:', err);
//                 setTermsOptions([]);
//             }
//         };

//         if (companyId) {
//             fetchTerms();
//             fetchLastTerms();
//         }


//     }, [companyId]);



//     const theme = useTheme();
//     const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
//     const isEditLocked = mode === 'edit' && isOrderLocked;

//     const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

//     const requiredAsteriskStyle = { '& .MuiFormLabel-asterisk': { color: 'red', }, };

//     const handlePopupClose = (data) => {
//         if (data?.success) {
//             setSnackbar({ open: true, message: data.message, severity: "success" });
//         }
//     };

//     // ─── Sync referenceDate with qoutationDate only in add mode ───────────
//     useEffect(() => {
//         if (mode === 'add') {
//             setReferenceDate(qoutationDate);
//         }
//     }, [qoutationDate, mode]);

//     // ─── When currencyOptions load or initialData.currencyId changes ──────
//     useEffect(() => {
//         if (!currencyOptions || currencyOptions.length === 0) return;
//         const cid = initialData?.currencyId ?? null;
//         if (cid == null) return;
//         const found = currencyOptions.find(opt => String(opt.id) === String(cid));
//         if (found) {
//             setSelectedCurrency(found);
//         } else {
//             setSelectedCurrency({ id: null, label: '-' });
//         }
//     }, [currencyOptions, initialData?.currencyId]);

//     // ─── Load auto-generated inquiry number ───────────────────────────────
//     useEffect(() => {
//         if (mode !== 'edit') {
//             fetchReceiptNo('Q');
//         }
//     }, [mode]);

//     async function fetchReceiptNo(code) {
//         try {
//             const { data } = await axios.get(`${API}/api/get-saleOrder-Number`, { headers: { 'Cache-Control': 'no-cache', }, params: { companyId, }, });
//             console.log('Fetched sale order number:', data);
//             setquotationNumber(data.saleOrderNumber || '');
//         } catch (err) {
//             console.error('Error fetching sale order number:', err);
//             setquotationNumber('');
//         }
//     }

//     // ─── Load all master lists ────────────────────────────────────────────
//     useEffect(() => {
//         const fetchMasters = async () => {
//             try {
//                 const [cur] = await Promise.all([axios.get(`${API}/currencymaster/search?mode=search&companyId=${companyId}`)]);
//                 const currencyData = transform(cur.data || [], 'CurrencyId', 'CurrencySymbol');
//                 console.log(cur.data);
//                 setCurrencyOptions(currencyData);
//                 if (initialData.currencyId) {
//                     const found = currencyData.find(opt => String(opt.id) === String(initialData.currencyId));
//                     setSelectedCurrency(found || { id: null, label: '-' });
//                 } else {
//                     setSelectedCurrency({ id: null, label: '-' });
//                 }
//             } catch (err) {
//                 console.error('Error fetching masters:', err);
//                 setCurrencyOptions([]);
//                 setLeadSourceOptions([]);
//                 setEmployeeOptions([]);
//                 setActivityOptions([]);
//                 setStatusOptions([]);
//                 setSelectedCurrency({ id: null, label: '-' });
//                 setSelectedLeadSource({ id: null, label: '-' });
//                 setSelectedEmployee({ id: null, label: '-' });
//                 setSelectedActivity({ id: null, label: '-' });
//                 setSelectedStatus({ id: null, label: '-' });
//             }
//         };
//         fetchMasters();
//     }, []);

//     // ─── Initialize from initialData ─────────────────────────────────────
//     useEffect(() => {
//         if (!initialData || Object.keys(initialData).length === 0) return;

//         setCompanyName(initialData.companyName || initialData.FirmName || '');
//         setSelectedClientId(initialData.clientId ?? null);

//         if (mode === 'edit') {
//             setSelectedTerms(
//                 initialData.TermsType
//                     ? {
//                         id: initialData.TermsType,
//                         label: String(initialData.TermsType)
//                     }
//                     : null
//             );
//         }

//         if (initialData.details) {
//             if (Array.isArray(initialData.details)) {
//                 setDetails(initialData.details);
//             } else if (typeof initialData.details === 'object') {
//                 const arr = Object.entries(initialData.details).map(([label, value]) => ({ label, value }));
//                 setDetails(arr);
//             }
//         } else {
//             const c = { city: initialData.city || '', state: initialData.state || '', mobileNo: initialData.mobileNo || '', emailId: initialData.emailId || '', contactPerson: initialData.contactPerson || '', gstNumber: initialData.gstNumber || '' };
//             setDetails([
//                 { label: 'City', value: c.city },
//                 { label: 'State', value: c.state },
//                 { label: 'mobileNo', value: c.mobileNo },
//                 { label: 'Email', value: c.emailId },
//                 { label: 'ContactPerson', value: c.contactPerson },
//                 { label: 'GST No.', value: c.gstNumber }
//             ]);
//         }

//         if (mode === 'edit') {
//             setqoutationDate(initialData.inquiryDate ? parseDateFlexible(initialData.inquiryDate) || dayjs() : dayjs());
//             setReferenceDate(initialData.referenceDate ? parseDateFlexible(initialData.referenceDate) || null : null);
//             setqnextFollowUpDate(initialData.nextFollowUpDate ? parseDateFlexible(initialData.nextFollowUpDate) || dayjs().add(7, 'day') : dayjs().add(7, 'day'));
//             setReferenceNumber(initialData.referenceNumber || '');
//             setquotationNumber(initialData.quotationNumber || '');
//         } else if (mode === 'order') {
//             setqoutationDate(dayjs());
//             setReferenceDate(initialData.inquiryDate ? parseDateFlexible(initialData.inquiryDate) || null : null);
//             setqnextFollowUpDate(initialData.nextFollowUpDate ? parseDateFlexible(initialData.nextFollowUpDate) || dayjs().add(7, 'day') : dayjs().add(7, 'day'));
//             setReferenceNumber(initialData.qoutationNumber || '');
//         } else if (mode === 'add') {
//             setqoutationDate(dayjs());
//             setReferenceDate(null);
//             setqnextFollowUpDate(dayjs().add(7, 'day'));
//             setReferenceNumber(initialData.referenceNumber || '');
//         }

//         setExchangeRate(initialData.exchangeRate || '');
//         setKindAttend(initialData.kindAttend || '');
//         setProject(initialData.project || '');
//         setAgentName(initialData.agentName || '');
//         setAgentCommission(initialData.agentCommission || '');
//         setRemark(initialData.remark || initialData.remarks || '');
//     }, [initialData, mode]);

//     // ─── Fetch search results ─────────────────────────────────────────────
//     useEffect(() => {
//         if (!companyName || !dropdownOpen) {
//             setSearchResults([]);
//             return;
//         }

//         const fetch = async () => {
//             try {
//                 const res = await axios.get(`${API}/api/company-search`, { params: { field: 'FirmName', search: companyName, companyId } });
//                 const data = Array.isArray(res.data.data) ? res.data.data : [];
//                 console.log('Company search results:', data);
//                 setSearchResults(data);
//             } catch (err) {
//                 console.error('Error fetching company search results:', err);
//                 setSearchResults([]);
//             }
//         };
//         fetch();
//     }, [companyName, dropdownOpen]);

//     // ─── Handle row selection in table ────────────────────────────────────
//     const onSelectResult = r => {
//         setSelectedClientId(r.id);
//         setCompanyName(r.FirmName || r.companyName || '');
//         setAgentName(r.AgentName || '');
//         setAgentCommission(r.AgentComm || '');

//         const c = { City: r.City || '', state: r.state || '', MobileNo: r.MobileNo || '', EmailId: r.EmailId || '', ContactPerson: r.ContactPerson || '', GSTNo: r.GSTNo || '' };
//         setDetails([
//             { label: 'City', value: c.City },
//             { label: 'State', value: c.state },
//             { label: 'mobileNo', value: c.MobileNo },
//             { label: 'Email', value: c.EmailId },
//             { label: 'ContactPerson', value: c.ContactPerson },
//             { label: 'GST No.', value: c.GSTNo }
//         ]);
//         setDropdownOpen(false);
//         setClientError(false);
//     };

//     // ─── Dropdown field for Autocomplete ──────────────────────────────────
//     const dropdownField = (label, options, value, setValue) => (
//         <Grid item xs={12} sm={8} md={12}>
//             <Autocomplete fullWidth options={options} getOptionLabel={opt => opt?.label || ''} value={value} onChange={(_, v) => setValue(v)} isOptionEqualToValue={(opt, val) => String(opt?.id) === String(val?.id)} disabled={!isEditable}
//                 renderInput={params => (
//                     <TextField {...params} label={label} size="small" InputLabelProps={{ shrink: Boolean(value) }} sx={{ '& .MuiOutlinedInput-root': { height: 40, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }} />
//                 )}
//             />
//         </Grid>
//     );

//     // ─── Next button ─────────────────────────────────────────────────────
//     const handleNext = () => {
//         if (!companyName && !quotationNumber) {
//             setError('Party & Order No. are required.');
//             return;
//         }
//         if (!selectedClientId) {
//             setClientError(true);
//             return;
//         }
//         setError('');
//         console.log('Selected currency (state):', selectedCurrency);
//         console.log('Exchange rate (state):', exchangeRate);
//         console.log('kindAttend, project, remark:', kindAttend, project, remark);

//         const payload = {
//             clientId: selectedClientId, inquiryNumber: quotationNumber, companyName, inquiryDate: qoutationDate && qoutationDate.isValid() ? qoutationDate.format('YYYY-MM-DD') : '', referenceNumber, referenceDate: referenceDate && referenceDate.isValid() ? referenceDate.format('YYYY-MM-DD') : '', editreferenceNumber: initialData?.editreferenceNumber || '', currencyId: selectedCurrency?.id ?? null, exchangeRate: exchangeRate === '' ? '' : Number(exchangeRate), nextFollowUpDate: qnextFollowUpDate && qnextFollowUpDate.isValid() ? qnextFollowUpDate.format('YYYY-MM-DD') : '', kindAttend, remarks: remark, project, selectedEmployee: selectedEmployee?.id ?? null, selectedLeadSource: selectedLeadSource?.id ?? null, selectedActivity: selectedActivity?.id ?? null, selectedStatus: selectedStatus?.id ?? null, agentName, agentCommission,
//             TermsType: selectedTerms?.label || null,
//             details: details.reduce((acc, curr) => {
//                 acc[curr.label] = curr.value;
//                 return acc;
//             }, {}),
//         };

//         console.log('ClientDetails onNext payload:', payload);
//         onNext(payload);
//     };

//     // ─── Allow editing only in 'add' or 'edit' modes ─────────────────────
//     const isEditable = mode === 'add' || mode === 'edit' || mode === 'order';

//     return (
//         <Paper elevation={2} sx={{ p: 1, overflowX: 'hidden' }}>
//             <Box display="flex" justifyContent="space-between" flexWrap="wrap" pt={1}>
//                 <Box sx={{ width: { xs: "100%", md: "calc(50% - 16px)" }, pr: { md: 3 } }}>
//                     {/* Party dropdown */}
//                     <Box ref={partyDropdownRef} tabIndex={-1} sx={{ position: 'relative', flex: '1 1 40%' }}
//                         onBlur={e => {
//                             if (!partyDropdownRef.current.contains(e.relatedTarget)) {
//                                 setDropdownOpen(false);
//                             }
//                         }}
//                     >
//                         <TextField disabled={!isEditable || disablePartyName || isEditLocked} fullWidth size="small" label="Party Name" variant="outlined" value={toProperCase(companyName)} required InputLabelProps={{ shrink: Boolean(companyName), sx: requiredAsteriskStyle }} sx={{ '& .MuiOutlinedInput-root': { height: '38px', display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { padding: '0 12px' } }} helperText={clientError ? "Client does not exist. Please add new client or select from the List" : ""} error={clientError}
//                             onChange={e => {
//                                 setCompanyName(toProperCase(e.target.value));
//                                 setDropdownOpen(true);
//                                 setSelectedClientId(null);   //  invalidate
//                                 setClientError(false);
//                             }}
//                             onBlur={() => {
//                                 if (companyName && !selectedClientId) {
//                                     setClientError(true);
//                                 }
//                             }}
//                         />

//                         {dropdownOpen && companyName && (
//                             <Paper elevation={0} sx={{ mt: 1, position: 'absolute', width: { xs: '100%', lg: '800px' }, zIndex: 10, border: '1px solid rgba(0,0,0,0.2)', borderRadius: 1, maxHeight: 240, overflowY: 'auto' }} >
//                                 {isSmallScreen ? (
//                                     /* ===================== CARD VIEW (SM / XS) ===================== */
//                                     <>
//                                         {searchResults.length > 0 ? (
//                                             searchResults.map((r, i) => (
//                                                 <Box key={i} sx={{ p: 1.2, borderBottom: '1px solid #eee', cursor: 'pointer' }}
//                                                     onMouseDown={() => {
//                                                         onSelectResult(r);
//                                                         // setSelectedClientId(r.ClientId);
//                                                         setCompanyName(toProperCase(r.FirmName));
//                                                         setClientError(false);
//                                                         setDropdownOpen(false);
//                                                     }}
//                                                 >
//                                                     <Box sx={{ fontWeight: 600, fontSize: '0.85rem' }}> {toProperCase(r.FirmName)} </Box>
//                                                     <Box sx={{ fontSize: '0.75rem', color: 'text.secondary' }}> GST: {r.GSTNo || '-'} </Box>
//                                                     <Box sx={{ fontSize: '0.75rem' }}> {toProperCase(r.ContactPerson) || '-'} • {r.MobileNo || '-'} </Box>
//                                                     <Box sx={{ fontSize: '0.75rem', color: 'text.secondary' }}> {toProperCase(r.City) || '-'} </Box>
//                                                 </Box>
//                                             ))
//                                         ) : (<Box sx={{ p: 2, textAlign: 'center', color: 'error.main' }}> Client not found </Box>)}

//                                         {/* Sticky Add New Client */}
//                                         <Box onMouseDown={() => setOpenClientPopup(true)} sx={{ position: 'sticky', bottom: 0, backgroundColor: '#fff', textAlign: 'center', p: 1, fontWeight: 600, color: 'primary.main', cursor: 'pointer', boxShadow: '0 -2px 6px rgba(0,0,0,0.08)' }} >
//                                             ➕ Add New Client
//                                         </Box>
//                                     </>
//                                 ) : (
//                                     /* ===================== TABLE VIEW (MD / LG) ===================== */
//                                     <Table size="small" stickyHeader>
//                                         <TableHead>
//                                             <TableRow>
//                                                 {['Company', 'GST No', 'Contact', 'Mobile', 'City'].map(h => (
//                                                     <TableCell key={h} sx={{ backgroundColor: '#E0E0E0', fontWeight: 600, fontSize: '0.75rem', position: 'sticky', top: 0, zIndex: 1 }} >
//                                                         {h}
//                                                     </TableCell>
//                                                 ))}
//                                             </TableRow>
//                                         </TableHead>

//                                         <TableBody>
//                                             {searchResults.length > 0 ? (
//                                                 searchResults.map((r, i) => (
//                                                     <TableRow key={i} hover sx={{ cursor: 'pointer' }}
//                                                         onMouseDown={() => {
//                                                             onSelectResult(r);
//                                                             setCompanyName(toProperCase(r.FirmName));
//                                                             setClientError(false);
//                                                             setDropdownOpen(false);
//                                                         }}
//                                                     >
//                                                         <TableCell>{toProperCase(r.FirmName)}</TableCell>
//                                                         <TableCell>{r.GSTNo}</TableCell>
//                                                         <TableCell>{toProperCase(r.ContactPerson)}</TableCell>
//                                                         <TableCell>{r.MobileNo}</TableCell>
//                                                         <TableCell>{toProperCase(r.City)}</TableCell>
//                                                     </TableRow>
//                                                 ))
//                                             ) : (
//                                                 <TableRow>
//                                                     <TableCell colSpan={5} align="center" sx={{ color: 'error.main' }}> Client not found </TableCell>
//                                                 </TableRow>
//                                             )}
//                                         </TableBody>

//                                         <TableFooter sx={{ position: 'sticky', bottom: 0, backgroundColor: '#fff' }} >
//                                             <TableRow hover onMouseDown={() => setOpenClientPopup(true)}>
//                                                 <TableCell colSpan={5} align="center" sx={{ color: 'primary.main', fontWeight: 600 }}>  ➕ Add New Client </TableCell>
//                                             </TableRow>
//                                         </TableFooter>
//                                     </Table>
//                                 )}
//                             </Paper>
//                         )}
//                     </Box>

//                     {/* Details display */}
//                     <Grid item xs={12} md={4} pt={2}>
//                         <TextField fullWidth size="small" label="Address" variant="outlined" disabled value={Array.isArray(details) ? toProperCase(details.map(d => `${d.label}: ${d.value}`).join(', ')) : ''} multiline rows={2.5} InputLabelProps={{ shrink: Array.isArray(details) && details.length > 0 }} sx={{ '& .MuiOutlinedInput-root': { height: "auto", display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }} />
//                     </Grid>

//                     <Box display="flex" gap={2} flex="1 1 40%" pt={2}>
//                         <Box sx={{ flex: '0 0 48%' }}>
//                             <TextField fullWidth size="small" label="Kind Attend" value={kindAttend} onChange={e => setKindAttend(e.target.value)} InputLabelProps={{ shrink: Boolean(kindAttend) }} disabled={!isEditable} sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' }, }} />
//                         </Box>
//                         <Box sx={{ flex: '0 0 48%' }}>
//                             <TextField fullWidth size="small" label="Project" value={project} onChange={e => setProject(e.target.value)} InputLabelProps={{ shrink: Boolean(project) }} disabled={!isEditable} sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' }, }} />
//                         </Box>
//                     </Box>

//                     <Box sx={{ mt: 2 }}>
//                         <TextField fullWidth size="small" label="Remark" disabled={!isEditable} multiline minRows={1} maxRows={6} value={remark} InputLabelProps={{ shrink: Boolean(remark) }} inputProps={{ maxLength: 250 }} sx={{ '& .MuiOutlinedInput-root': { height: 'auto', alignItems: 'flex-start' } }}
//                             onChange={(e) => {
//                                 const val = e.target.value;
//                                 if (val.length <= 250) setRemark(val);
//                                 else setRemark(val.slice(0, 250));
//                             }}
//                         />
//                         <Typography variant="caption" sx={{ display: 'block', mt: 0.5, textAlign: 'right', color: 'text.secondary' }}>
//                             {remark.length}/250
//                         </Typography>
//                     </Box>

//                     <Box display="flex" justifyContent="flex-start">
//                         <Box sx={{ width: '20%', mt: "-8px" }}>
//                             <Autocomplete
//                                 fullWidth
//                                 size="small"
//                                 options={termsOptions}
//                                 getOptionLabel={(opt) => opt?.label || ''}
//                                 value={selectedTerms}
//                                 onChange={(_, v) => setSelectedTerms(v)}
//                                 isOptionEqualToValue={(opt, val) => String(opt?.id) === String(val?.id)}
//                                 // disabled={!isEditable}
//                                 renderInput={(params) => (
//                                     <TextField
//                                         {...params}
//                                         label="Terms"
//                                         size="small"
//                                         InputLabelProps={{ shrink: Boolean(selectedTerms) }}
//                                         sx={{
//                                             '& .MuiOutlinedInput-root': {
//                                                 height: 38,
//                                                 display: 'flex',
//                                                 alignItems: 'center'
//                                             },
//                                             '& .MuiOutlinedInput-input': {
//                                                 fontSize: '0.875rem',
//                                                 padding: '0 12px'
//                                             }
//                                         }}
//                                     />
//                                 )}
//                             />
//                         </Box>
//                     </Box>
//                 </Box>

//                 <Box sx={{ width: { xs: "100%", md: "calc(50% - 46px)" }, pt: { xs: 2, md: 0 } }} alignSelf="right">
//                     <Box display="flex" gap={2} flex="1 1 40%">
//                         <Box sx={{ flex: '0 0 48%' }}>
//                             <TextField fullWidth size="small" label="Order No." variant='outlined' value={quotationNumber} disabled InputLabelProps={{ shrink: true }} sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' }, }} />
//                         </Box>

//                         <Box sx={{ flex: '0 0 48%' }}>
//                             <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
//                                 <DatePicker label="Order Date" value={qoutationDate} onChange={setqoutationDate}
//                                     slots={{
//                                         textField: (params) => (
//                                             <TextField {...params} size="small" variant="outlined" value={qoutationDate ? dayjs(qoutationDate).format('DD/MM/YYYY') : ''} InputLabelProps={{ shrink: true }} disabled sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' }, }} />
//                                         ),
//                                     }}
//                                 />
//                             </LocalizationProvider>
//                         </Box>
//                     </Box>

//                     <Box display="flex" gap={2} flex="1 1 40%" pt={2}>
//                         <Box sx={{ flex: '0 0 48%' }}>
//                             <TextField fullWidth size="small" variant='outlined' label="Party PO No." value={referenceNumber} onChange={e => setReferenceNumber(e.target.value)} InputLabelProps={{ shrink: Boolean(referenceNumber) }} disabled={!isEditable || isEditLocked} sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' }, }} />
//                         </Box>

//                         <Box sx={{ flex: '0 0 48%' }}>
//                             <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
//                                 <DatePicker label="Party PO Dt" value={referenceDate} onChange={(newValue) => setReferenceDate(newValue)} disabled={!isEditable || isEditLocked}
//                                     slots={{
//                                         textField: (params) => (
//                                             <TextField {...params} fullWidth size="small" variant="outlined" value={referenceDate && referenceDate.isValid() ? referenceDate.format('DD/MM/YYYY') : ''} InputLabelProps={{ shrink: Boolean(referenceDate) || mode === 'add' }}
//                                                 sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' }, }}
//                                             />
//                                         )
//                                     }}
//                                 />
//                             </LocalizationProvider>
//                         </Box>
//                     </Box>

//                     <Box display="flex" gap={2} flex="1 1 40%" pt={2}>
//                         <Box sx={{ flex: '0 0 48%', display: 'flex', gap: 1, alignItems: 'center' }}>
//                             <Box sx={{ flex: '0 0 50%' }}> {dropdownField('Currency', currencyOptions, selectedCurrency, setSelectedCurrency)} </Box>
//                             <Box sx={{ flex: '0 0 47%' }}>
//                                 <TextField fullWidth size="small" type="number" variant="outlined" label="Ex Rate" value={exchangeRate} InputLabelProps={{ shrink: Boolean(exchangeRate) }} disabled={!isEditable} sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' }, }}
//                                     onChange={(e) => {
//                                         const value = e.target.value;
//                                         if (/^\d*\.?\d{0,2}$/.test(value)) {
//                                             setExchangeRate(value);
//                                         }
//                                     }}
//                                 />
//                             </Box>
//                         </Box>
//                     </Box>

//                     <Box display="flex" gap={2} flex="1 1 40%" pt={2}>
//                         <Box sx={{ flex: '0 0 48%' }}> <TextField fullWidth label="Agent Name" value={toProperCase(agentName)} onChange={e => setAgentName(toProperCase(e.target.value))} InputLabelProps={{ shrink: Boolean(agentName) }} variant="outlined" size="small" disabled={!isEditable} sx={{ '& .MuiOutlinedInput-root': { backgroundColor: 'white', height: '40px' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 10px' } }} /> </Box>

//                         <Box sx={{ flex: '0 0 48%' }}>
//                             <TextField fullWidth label="Agent Commission (%)" value={agentCommission} InputLabelProps={{ shrink: Boolean(agentCommission) }} variant="outlined" size="small" type="number" disabled={!isEditable} sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' }, }}
//                                 onChange={e => {
//                                     const v = e.target.value;
//                                     if (v === '') {
//                                         setAgentCommission('');
//                                         return;
//                                     }
//                                     const re = /^(?:100(?:\.(?:0{0,2}))?|[0-9]{1,2}(?:\.\d{0,2})?)$/;
//                                     if (re.test(v)) {
//                                         setAgentCommission(v);
//                                     }
//                                 }}
//                             />
//                         </Box>
//                     </Box>
//                 </Box>
//             </Box>

//             {!!error && (<Typography color="error" mt={2}> {error} </Typography>)}

//             <Box mt={4} display="flex" justifyContent="flex-end"> <Button variant="contained" onClick={handleNext} disabled={!selectedClientId}>Next</Button> </Box>

//             {/* Popups */}
//             <Dialog open={openClientPopup} fullWidth maxWidth="md" onClose={(event, reason) => {
//                 if (reason === 'backdropClick') return;
//                 setOpenClientPopup(false);
//             }} PaperProps={{
//                 sx: {
//                     width: { xs: "95%", },
//                     m: { xs: 0 }
//                 }
//             }}>
//                 <DialogContent sx={{ p: { xs: 0 } }}>
//                     <ClientMaster mode="add" onPopupCancel={(data) => { handlePopupClose(data); setOpenClientPopup(false) }} connectionString={connectionString} />
//                 </DialogContent>
//             </Dialog>
//             <Dialog open={openCurrencyPopup} onClose={() => setOpenCurrencyPopup(false)}>
//                 <DialogContent>
//                     <CurrencyMaster mode="add" onPopupCancel={() => setOpenCurrencyPopup(false)} connectionString={connectionString} />
//                 </DialogContent>
//             </Dialog>
//             <Dialog open={openLeadSourcePopup} onClose={() => setOpenLeadSourcePopup(false)}>
//                 <DialogContent>
//                     <LeadSourceMaster mode="add" onPopupCancel={() => setOpenLeadSourcePopup(false)} connectionString={connectionString} />
//                 </DialogContent>
//             </Dialog>
//             <Dialog open={openEmployeePopup} onClose={() => setOpenEmployeePopup(false)}>
//                 <DialogContent>
//                     <UserMaster mode="add" onPopupCancel={() => setOpenEmployeePopup(false)} connectionString={connectionString} />
//                 </DialogContent>
//             </Dialog>
//             <Dialog open={openActivityPopup} onClose={() => setOpenActivityPopup(false)}>
//                 <DialogContent>
//                     <ActivityMaster mode="add" onPopupCancel={() => setOpenActivityPopup(false)} connectionString={connectionString} />
//                 </DialogContent>
//             </Dialog>
//             <Dialog open={openStatusPopup} onClose={() => setOpenStatusPopup(false)}>
//                 <DialogContent>
//                     <LeadStatusMaster mode="add" onPopupCancel={() => setOpenStatusPopup(false)} connectionString={connectionString} />
//                 </DialogContent>
//             </Dialog>

//             <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={() => setSnackbar(s => ({ ...s, open: false }))} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} >
//                 <Alert onClose={() => setSnackbar(s => ({ ...s, open: false }))} severity={snackbar.severity} variant="filled" sx={{ width: '100%' }} >
//                     {snackbar.message}
//                 </Alert>
//             </Snackbar>
//         </Paper>
//     );
// }
